define((require) => {
    "use strict";

    const Window = require("shared/services/Window");

    const domUtil = {
        /*
         * Load script
         *
         * @param {String} url - Url of the script
         * @param {windowElement} windowElement - Window Element. Optional. Defaults to current window.
         *
         * @returns {Element} return script DOM element
         */
        createScriptElement(url, windowElement) {
            windowElement = windowElement || Window.self();
            const scriptElement  = windowElement.document.createElement("script");
            scriptElement.src = url;
            scriptElement.type = "text/javascript";

            return scriptElement;
        },

        /**
         * This function will take the innerDOM of an HTMLElement and encapsulate it.
         *
         * @param {HTMLElement} htmlElement     - The element where the innerDOM is going to be wrapped.
         * @param {HTMLElement} wrapperElement  - The element which encapsulate the innerDOM of the {@see htmlElement}
         */
        encapsulateInnerDom(htmlElement, wrapperElement) {
            while (htmlElement.firstChild) {
                wrapperElement.appendChild(htmlElement.firstChild);
            }

            htmlElement.appendChild(wrapperElement);
        }

    };

    return domUtil;
});



// WEBPACK FOOTER //
// ./src/shared/util/DomUtil.js